import {
  Stack,
  Text,
  Icon,
  Code,
  Badge,
  Link,
  Panel,
  PanelHeader,
  PanelTitle,
  PanelSection,
  InlineStack,
  SkeletonText,
} from '@customerio/pluma-components/react';
import type { ServicesApiEnvHealthEventNameCount } from '@/services/api/services-api';

export function TopEventsPanel({
  events,
  isLoading,
  workspaceId,
}: {
  events?: ServicesApiEnvHealthEventNameCount[];
  isLoading: boolean;
  workspaceId: number;
}) {
  return (
    <Panel>
      <PanelHeader>
        <PanelTitle text="product-h4" color="subtle">
          <InlineStack gap="050" alignBlock="center">
            <Icon name="trigger-event" size="sm" color="bold" />
            Top events today
          </InlineStack>
        </PanelTitle>
      </PanelHeader>
      <PanelSection>
        {isLoading ? (
          <SkeletonText size="s" lines={5} />
        ) : events != null && events.length > 0 ? (
          <Stack gap="100">
            {events.map((evt) => (
              <InlineStack key={evt.name} alignInline="space-between" alignBlock="center" py="050">
                <Link
                  variant="secondary"
                  href={`/workspaces/${workspaceId}/journeys/data-index/events/${encodeURIComponent(evt.name)}`}
                >
                  <Code size="xs">{evt.name}</Code>
                </Link>
                <Badge>{evt.count.toLocaleString()}</Badge>
              </InlineStack>
            ))}
          </Stack>
        ) : (
          <Text size="s" color="subtle">
            No events tracked today
          </Text>
        )}
      </PanelSection>
    </Panel>
  );
}
